import cx from "classnames";
import React from "react";
import Tooltip from "./../../../wix-rich-content-common/lib/Tooltip";
import styles from "./ToolbarButton-scss";
const ToolbarButton = React.forwardRef(
  ({
    isMobile = false,
    active,
    disabled,
    tooltip,
    onClick,
    Icon,
    dataHook,
    label
  }, ref) => {
    return /* @__PURE__ */ React.createElement(Tooltip, { key: tooltip, content: tooltip, tooltipOffset: { x: 0, y: -8 } }, /* @__PURE__ */ React.createElement(
      "button",
      {
        ref,
        className: cx(styles.toolbarButtonWrapper, {
          [styles.mobileToolbarButtonWrapper]: isMobile,
          [styles.active]: active,
          [styles.disabled]: disabled
        }),
        onClick: !disabled ? onClick : void 0,
        onMouseDown: (e) => e.preventDefault(),
        "data-hook": dataHook,
        disabled,
        type: "button"
      },
      /* @__PURE__ */ React.createElement("div", { className: cx(styles.iconTextWrapper, { [styles.mobileToolbarButton]: isMobile }) }, /* @__PURE__ */ React.createElement(Icon, null), label && /* @__PURE__ */ React.createElement("div", null, label))
    ));
  }
);
var ToolbarButton_default = ToolbarButton;
export {
  ToolbarButton_default as default
};
//# sourceMappingURL=ToolbarButton.js.map
